import { environment } from '@blueberry/framework/config'
import * as Sentry from '@sentry/browser'

export type SentryConfig = {
  dsn: string
}

const getConfig = (): Sentry.BrowserOptions => {
  switch (environment) {
    case 'local': {
      return {
        tracesSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
      }
    }
    case 'dev':
    case 'staging':
      return {
        tracesSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
      }
  }

  return {
    tracesSampleRate: 0.1,
    /// Session Replay
    // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.1,
    // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 0.1,
  }
}

export const initializeSentry = (config: SentryConfig) => {
  Sentry.init({
    ...getConfig(),
    dsn: config.dsn,
    environment: environment,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'local.blueberrypediatrics.dev'],
      }),
      new Sentry.Replay(),
    ],
  })
}
